import React from "react";

import "./About.css";
import Footer from "./Footer";

const About = () => {
  return (
    <React.Fragment>
      <div className="mx-auto about-us text-justify">
        <strong>Karty</strong> is a MERN website. It is a simple website which
        uses basic implementation of technologies. It is simply an ecommerce
        website which displays products in form of cards. Payment is done via
        paypal. Products are visible only after you are authenticated
        {"(logged in for existing users or Signed up for new users.)"}
        <br />
        It fetches the products from backend and updates them on purchase. The
        site does not uses token for now so every time the browser is refreshed
        you need to login again and add items again. The paypal button needs to
        be clicked one or more time for proper working(Sorry for that. Will be
        fixed soon).
        <p className="text-center">
          <strong>Enjoy Shopping</strong>
        </p>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default About;
